import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { SetDepositLimitsComponent } from './set-deposit-limits/set-deposit-limits.component';
import { SetTimeLimitsComponent } from './set-time-limits/set-time-limits.component';
import { SetLossLimitsComponent } from './set-loss-limits/set-loss-limits.component';
import { ServicesSharedModule } from 'src/app/services/services-shared.module';
import { SetSingleBetLimitsComponent } from './set-single-bet-limits/set-single-bet-limits.component';
import { LimitsHistoryComponent } from './limits-history/limits-history.component';
import { SpendLimitComponent } from './spend-limit/spend-limit.component';
import { LimitConfirmationComponent } from './limit-confirmation/limit-confirmation.component';


@NgModule({
  declarations: [
    SetDepositLimitsComponent,
    SetTimeLimitsComponent,
    SetLossLimitsComponent,
    SetSingleBetLimitsComponent,
    LimitsHistoryComponent,
    LimitConfirmationComponent,
    SpendLimitComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
    ServicesSharedModule
  ]
})
export class LimitsModule {}